document.querySelector(".site-header__icon-search").addEventListener("click", handleSearch);
document.querySelector('.search-input').addEventListener('input', updateValue);
document.querySelector('.search-input').addEventListener('keyup', searchRedirect);
document.querySelector('.search-input').addEventListener('keyup', searchRedirect);
document.querySelector('.search-input-mobile').addEventListener('keyup', searchRedirect);

function handleSearch(e) {
    const container = document.querySelector(".site-header__search");
    container.classList.toggle('active');
    
}

function updateValue(e) {
    console.log(e.target.value)
    const container = document.querySelector(".site-header__search");

    if(e.target.value.length > 0){
        container.classList.add('has-text');
    } else {
        container.classList.remove('has-text');
    }
}

function searchRedirect(e){
    if (e.keyCode === 13) {
        // Cancel the default action, if needed
        e.preventDefault();
        // Trigger the button element with a click
        window.location.href = "https://www.nordic.com/search/?q="+ e.target.value +"";
      }
}